module.exports = __webpack_public_path__ + "media/images/flags/TR-49fb5a993bec0eeeac20ec2e4c68197e.svg";